module.exports = __webpack_public_path__ + "img/equipped.a822b0fd.svg";